import { Route, Navigate } from 'react-router-dom';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { profileSelector } from '../store/authentication/authenticationReducerSelectors';
import { getRouterScreens } from './getRouterScreens/getRouterScreens';
// import NewCreateConsultationSteps from '../components/pages/connected/CreateConsultation/NewCreateConsultationSteps';
// import DashboardHome from '../components/pages/connected/Dashboard/DashboardHome/DashboardHome';
// import DashboardCommerciaux from '../components/pages/connected/Dashboard/DashboardCommerciaux/DashboardCommerciaux';
// import DashboardProspects from '../components/pages/connected/Dashboard/DashboardProspects/DashboardProspects';
// import DashboardHistory from '../components/pages/connected/Dashboard/DashboardHistoryENT/DashboardHistoryENT';
// import DashboardInvoices from '../components/pages/connected/Dashboard/DashboardInvoices/DashboardInvoices';
// import DashboardConsultation from '../components/pages/connected/Dashboard/DashboardConsultation/DashboardConsultation';
import { useConfigureApi } from '../hooks/useConfigureApi/useConfigureApi';
import { Helmet } from 'react-helmet';
import { User, UserDIR, UserENT, UserPUB, UserRoles } from '../types/models/user/user.types';
import { Commercial } from '../types/api/endpoints/commercial/commercial.types';
import { commonRoutesList } from './router.data';
import { SentryRoutes } from '../App';
import Contact from '../components/pages/commons/Contact/Contact';
import DashboardCommerciaux from '../components/pages/connected/Dashboard/DashboardCommerciaux/DashboardCommerciaux';
import RedirectToLogin from './redirects/RedirectToLogin';

// export const Redirector = ({ profile }: {profile: User | UserPUB | UserENT | UserDIR | Commercial | null}) => {
//   if (profile) {
//     if (profile.role === UserRoles.AcheteurPublic) {
//       if (profile.id_step === 3) {
//         return <Route path="*" element={<Navigate to="/dashboard" replace />} />
//       } else {
//         return <Route path="*" element={<Navigate to={`/step_wizard/${profile.role}`} replace />} />
//       }
//     } else if (profile.role === UserRoles.Entreprise) {
//       if (profile.id_step === 4) {
//         return <Route path="*" element={<Navigate to="/dashboard" replace />} />
//       } else {
//         return <Route path="*" element={<Navigate to={`/step_wizard/${profile.role}`} replace />} />
//       }
//     } else {
//       return <Route path="*" element={<Navigate to="/" replace />} />
//     }
//   }
//   return <Route path="*" element={<Navigate to="/" replace />} />
// }

export const getDefaultRedirect = (
  profile: User | UserPUB | UserENT | UserDIR | Commercial | null
) => {
  if (profile) {
    console.log('profile', profile)
    if (profile.role === UserRoles.AcheteurPublic) {
      if (profile.id_step === 5) {
        return '/dashboard';
      } else {
        return `/step_wizard/${profile.role}`;
      }
    } else if (profile.role === UserRoles.Entreprise) {
      if (profile.id_step === 3) {
        return '/dashboard';
      } else {
        return `/step_wizard/${profile.role}`;
      }
    } else if (profile.role === UserRoles.Commercial || profile.role === UserRoles.DirecteurCommercial) {
      return '/dashboard'
    } else {
      return '/';
    }
  }
  return '/';
};

export const Router = () => {

  const isConfigured = useConfigureApi();

  const profile = useSelector(profileSelector);

  const currentRoutes = useMemo(() => getRouterScreens(profile), [profile]);

  const redirect = useMemo(() => getDefaultRedirect(profile), [profile]);

  // const updatedRoutes = useMemo(
  //   () => {
  //     if (profile && profile.role === UserRoles.Commercial) {
  //       const { type } = profile as Commercial

  //     } else {
  //       return currentRoutes;
  //     }
  //   },
  //   [currentRoutes, profile]
  // );

  // useEffect(() => {
  //   if (profile) {
  //     if ([UserRoles.AcheteurPublic, UserRoles.Entreprise].includes(profile.role) && profile.id_step < 4) {
  //       naviagte(`/step_wizard/${profile.role}`)
  //     }
  //   }
  // }, [profile]);

  if (!isConfigured) {
    return null;
  }

  return (
    <SentryRoutes>
      {[...commonRoutesList, ...currentRoutes].map(
        ({ component: Component, path, title }, index) => (
          <Route
            key={index}
            path={path}
            element={
              <>
                <Helmet>
                  <title>{title}</title>
                </Helmet>
                <Component />
              </>
            }
          />
        )
      )}
      <Route path="dashboard" element={null}>
        <Route path="nouvelle_consultation" element={null} />
        <Route path="nouvelle_consultation/:consultationId" element={null} />
        <Route path="consultations" element={null} />
        <Route path="consultations/:consultationId" element={null} />
        <Route path="consultations/:consultationId/questions" element={null} />
        <Route path="consultations/:consultationId/devis" element={null} />
        <Route path="consultations_in_progress" element={null} />
        <Route path="historique" element={null} />
        <Route path="historique/:consultationId" element={null} />
        <Route path="historique/:consultationId/questions" element={null} />
        <Route path="historique/:consultationId/devis" element={null} />
        <Route path="prospects" element={null} />
        <Route path="prospection" element={null} />
        <Route path="stats" element={null} />
        <Route path="results" element={null} />
        <Route path="companies" element={null} />
        <Route path="map" element={null} />
        <Route path="receipts" element={null} />
        <Route path="subscriptions" element={null} />
        <Route path="facturation" element={null} />
        <Route path="facturation/:month/:year" element={null} />
        <Route path="commerciaux" element={<DashboardCommerciaux />} />
      </Route>
      <Route path="dashboard_success" element={<RedirectToLogin />} />
      <Route path="profile" element={null}>
        <Route path="stats" element={null} />
        <Route path="credentials" element={null} />
        <Route path="entity" element={null} />
        <Route path="company" element={null} />
        <Route path="subusers" element={null} />
      </Route>
      <Route path="contact" element={<Contact />} />
      {/* <Route path="dashboard" element={<DashboardHome />}>
        <Route path="commerciaux" element={<DashboardCommerciaux />} />
        <Route path="prospects" element={<DashboardProspects />} />
        <Route path="consultations" element={<DashboardConsultation />} />
        <Route path="historique" element={<DashboardHistory />} />
        <Route path="facturation" element={<DashboardInvoices />} />
        <Route path="nouvelle_consultation" element={<NewCreateConsultationSteps />} />
        <Route
          path="nouvelle_consultation/:consultationId"
          element={<NewCreateConsultationSteps />}
        />
      </Route> */}
      <Route path="*" element={<Navigate to={redirect} replace />} />
      {/* <Redirector {...{ profile }} />  */}
    </SentryRoutes>
  );
};
